import { DateTime } from 'luxon'
import { localeString } from '@/config/helpers.js'

export const replaceVariables = (string, object) => {
  return string.replace(/\${([^{}]*)}/g, (a, b) => {
    let r = object[b]
    return typeof r === 'string' || typeof r === 'number' ? r : a
  })
}

export const findReplaceableVariables = (string) => {
  if (!string) return null
  return string.match(/\${([^{}]*)}/g)
}

export const stringifyListPtBR = (list) => {
  if (!list?.length) return ''
  if (list.length === 1) return list[0]
  return `${list.slice(0, -1).join(', ')} ou ${list[list.length - 1]}`
}
const lengthVariableFormatter = (value) => {
  if (Array.isArray(value)) return value.length
  if (value?.value?.length) return value.value.length
  if (value?.clients_qty_from_file) return value.clients_qty_from_file
  if (value?.values?.length) return value.values.length
  if (Number.isInteger(value)) return value
  return 0
}

export const variableFormatters = {
  length: lengthVariableFormatter,
  lengthAllWhenZero: (value) => {
    const length = lengthVariableFormatter(value)
    return length || 'qualquer'
  },
  currentValue: (value) => (['number', 'string'].includes(typeof value) ? localeString(value || 0) : value || 0),
  arrayCurrentValueLabel: (values) => {
    return (values && stringifyListPtBR(values.map((values) => values.label))) || ''
  },
  arrayCurrentValue: (values) => (values && stringifyListPtBR(values)) || '',
  initialValue: (value) => (value?.length >= 1 ? value[0] : value || 0),
  finalValue: (value) => (value?.length >= 2 ? value[1] : value || 0),
  initialMoneyValue: (value) => `R$ ${localeString(value?.length >= 1 ? value[0] : value || 0)}`,
  finalMoneyValue: (value) => `R$ ${localeString(value?.length >= 2 ? value[1] : value || 0)}`,
  initialDateValue: (value) => {
    const dateValue = value?.length >= 1 ? value[0] : value
    if (dateValue) return DateTime.fromFormat(dateValue, 'yyyyMMdd').toFormat('dd/MM/yyyy')
    return ''
  },
  finalDateValue: (value) => {
    const dateValue = value?.length >= 2 ? value[1] : value
    if (!dateValue) return ''
    const date = DateTime.fromFormat(dateValue, 'yyyyMMdd')
    if (!date.isValid) return ''
    return date.toFormat('dd/MM/yyyy')
  },
  dateValue: (value) => {
    if (!value || typeof value !== 'string') return ''
    const date = DateTime.fromFormat(value, 'yyyyMMdd')
    if (!date.isValid) return ''
    return date.toFormat('dd/MM/yyyy')
  },
  name: (value) => value?.name || '',
  label: (value) => value?.label || '',
  description: (value) => value?.description || 'Sem descrição',
  updatedAt: (value) => (value?.updated_at ? DateTime.fromISO(value.updated_at).toFormat('dd/MM/yyyy HH:mm:ss') : ''),
  dynamicRangeText: (value) => {
    if (value?.length !== 2) return ''
    let newText = ''
    const getInitialValue = (initialValue) => `${String(initialValue).padStart(2, '0')}:00`
    const getEndValue = (endValue) => `${String(endValue).padStart(2, '0')}:59`
    if (value[0] !== false && value[1] !== false) {
      newText = `entre as ${getInitialValue(value[0])} e ${getEndValue(value[1])}`
    } else if (value[0] !== false) {
      newText = `a partir das ${getInitialValue(value[0])}`
    } else if (value[1] !== false) {
      newText = `até as ${getEndValue(value[1])}`
    }
    return newText
  },
  fullDateValue: (fullDateValue) => {
    if (fullDateValue?.type === 'dynamic_range') {
      return fullDateValue.text
    } else if (fullDateValue?.type === 'fixed_range') {
      const initialDateValue = fullDateValue?.value?.[0]
      const finalDateValue = fullDateValue?.value?.[1]
      if (!initialDateValue || !finalDateValue) return ''
      const initialDate = DateTime.fromFormat(initialDateValue, 'yyyyMMdd')
      const finalDate = DateTime.fromFormat(finalDateValue, 'yyyyMMdd')
      if (!initialDate.isValid || !finalDate.isValid) return ''
      return `entre ${initialDate.toFormat('dd/MM/yyyy')} e ${finalDate.toFormat('dd/MM/yyyy')}`
    } else if (fullDateValue?.type === 'empty_range') {
      return 'desde o início'
    }
    return ''
  },
  rfvCustersLabels: (values) => {
    const translators = {
      champions: 'Campeão',
      loyals: 'Cliente leal',
      promising: 'Promissor',
      at_risk: 'Em risco',
      low_value: 'Baixo valor',
      losses: 'Perdido',
      never_bought: 'Nunca comprou',
    }
    if (!values) return ''
    return values
      .map((value) => `"${translators[value]}"`)
      .join(', ')
      .replace(/, ([^,]*)$/, ' ou $1')
  },
  dreClustersLabels: (values) => {
    const translators = {
      first_buy: 'Novos',
      inactive: 'Upsell',
      lost: 'Recuperados',
      active: 'Recorrentes',
    }
    if (!values) return ''
    return values
      .map((value) => `"${translators[value]}"`)
      .join(', ')
      .replace(/, ([^,]*)$/, ' ou $1')
  },
}
